import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=077c32c0&scoped=true"
import script from "./poster.vue?vue&type=script&lang=ts"
export * from "./poster.vue?vue&type=script&lang=ts"
import style0 from "./poster.vue?vue&type=style&index=0&id=077c32c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c32c0",
  null
  
)

export default component.exports